import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import Hero from './components/Hero';
import WhatIs from './components/WhatIs';
import Problems from './components/Problems';
import Connections from './components/Connections';
import BusinessLoop from './components/BusinessLoop';
import EcosystemDiagram from './components/EcosystemDiagram';
import CoreValue from './components/CoreValue';
import Closing from './components/Closing';

export default function Weiju() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="味聚｜餐饮消费与供应链数字化服务平台｜敬龙国际"
        description="味聚是一套连接消费者、餐饮商家、供应商及平台运营方的综合服务平台，通过聚餐社交、餐饮消费、商品采购、供应链协同、数字权益及平台治理，打通从用户消费到商家经营、从商品供应到交易履约的完整业务链路。"
        keywords="味聚,智慧餐饮,聚餐社交,供应链协同,甄选商城,数字权益,敬龙国际"
        path="/weiju"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '味聚｜餐饮消费与供应链数字化服务平台',
          description:
            '味聚连接消费者、餐饮商家与供应链，以聚餐社交、餐饮经营、供应链协同和数字权益打通人、店、货、场、交易全链路。',
        }}
      />

      <Hero />
      <Breadcrumb items={[{ label: '客户案例', href: '/cases' }, { label: '敬龙国际「味聚」项目' }]} />

      <main>
        <WhatIs />
        <Problems />
        <Connections />
        <BusinessLoop />
        <EcosystemDiagram />
        <CoreValue />
        <Closing />
      </main>

      <Footer />
    </div>
  );
}